import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch } from 'react-router-dom';
import { Segment, Container, Menu } from 'semantic-ui-react';
import { es404 } from '../../Errors';
import {
  AlertBox,
  ConfirmBox,
  // setAlertMsg,
  // askConfirmation,
} from '../../../components/Modals';
import { MenuLinkItem } from '../../../components/Menu';
// import { logout } from '../../../helpers/auth';
// import { firebaseAuth, firebaseDb } from '../../../config/constants';
import ViewAdmin from './ViewAdmin';
import ListAdmins from './ListAdmins';
import ListPreregistrations from './ListPreregistrations';
import AddAdmin from './AddAdmin';

export default class AccessManagement extends Component {
  static propTypes = {
    habilitations: PropTypes.object.isRequired,
  }

  state = {}

  render() {
    return (
      <Container>
        <Segment>
          <Menu secondary pointing>
            <MenuLinkItem
              to="/access-mgt/view"
              activeOnlyWhenExact={false}
              label="Editer les droits d'un administrateurs"
            />
            <MenuLinkItem to="/access-mgt/list" label="Consulter la liste des administrateurs" />
            <MenuLinkItem to="/access-mgt/preregistrations" label="Préinscriptions en attente" />
            <MenuLinkItem to="/access-mgt/add" label="Ajouter un administrateur" />
          </Menu>

          <Container>
            <Switch>
              <Route
                path="/access-mgt/view/:id?"
                component={props => (<ViewAdmin
                  habilitations={this.props.habilitations}
                  {...props}
                />)}
              />
              <Route
                path="/access-mgt/list"
                component={() => <ListAdmins habilitations={this.props.habilitations} />}
                exact
              />
              <Route
                path="/access-mgt/add"
                component={() => <AddAdmin habilitations={this.props.habilitations} />}
                exact
              />
              <Route
                path="/access-mgt/preregistrations"
                component={() => <ListPreregistrations habilitations={this.props.habilitations} />}
                exact
              />
              <Redirect exact from="/access-mgt" to="/access-mgt/view" />
              <Route component={es404} />
            </Switch>
          </Container>
          <AlertBox
            propagateClosure={() => this.setState({ alert: { open: false } })}
            {...this.state.alert}
          />
          <ConfirmBox
            propagateClosure={() => this.setState({ confirm: { open: false } })}
            {...this.state.confirm}
          />
        </Segment>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/AccessManagement/index.js